// extracted by mini-css-extract-plugin
export default {"title":"SectionHeader_title__9RzMB"};